import React from 'react';
import { motion } from 'framer-motion';
import { ChristmasSectionHeading } from './ChristmasSectionHeading';
import { processSteps } from '../../../data/christmasPage';
function BrushStepLabel({
  number
}: {
  number: number;
}) {
  return <span className="relative inline-flex items-center px-7 py-3" data-id="element-220" data-mp="1m59grcsbmomq">
      <svg aria-hidden="true" viewBox="0 0 220 64" preserveAspectRatio="none" className="absolute inset-0 h-full w-full" data-id="element-221" data-mp="1h6pvzfpgrivy">
        <path d="M6 18 C30 8 70 12 110 9 C150 6 190 4 214 12 C218 22 210 28 216 36 C212 46 218 52 208 58 C170 62 120 56 80 60 C50 62 22 60 8 54 C2 46 10 40 4 32 C8 26 2 22 6 18 Z" fill="#F5C518" data-id="element-222" data-mp="oiagyt6c10km" />
        <path d="M14 14 C60 10 120 12 196 8" stroke="#E0AE0B" strokeWidth="3" fill="none" strokeLinecap="round" data-id="element-223" data-mp="yfyl29ptvkfg" />
        <path d="M18 52 C70 56 130 52 200 54" stroke="#E0AE0B" strokeWidth="2.5" fill="none" strokeLinecap="round" data-id="element-224" data-mp="2dw78adiyc36m" />
      </svg>
      <span className="relative font-display text-2xl font-semibold uppercase tracking-[0.06em] text-forest-900 md:text-3xl" data-id="element-225" data-mp="29vdkrl9f8qe9">
        Step {number}
      </span>
    </span>;
}
export function ChristmasProcessSection() {
  return <section id="christmas-process" aria-labelledby="christmas-process-title" className="scroll-mt-32 bg-cream py-20 md:py-28" data-id="element-226" data-mp="usg3nd37wurv">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-227" data-mp="zrssg3dngbx3">
        <ChristmasSectionHeading eyebrow="Our Process" title="Five simple steps to a glowing holiday." titleId="christmas-process-title" data-id="element-228" data-mp="zp6ixy777mc8" />
        <ol className="mt-16 space-y-16 md:space-y-24" data-id="element-229" data-mp="7351br67ysbm">
          {processSteps.map((step, i) => {
          const reversed = i % 2 === 1;
          return <motion.li key={step.title} initial={{
            opacity: 0,
            y: 28
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} className={`grid items-center gap-8 md:grid-cols-2 md:gap-14 ${reversed ? 'md:[&>*:first-child]:order-2' : ''}`} data-id="element-230" data-mp="gtq8i2zyl565" data-mpi={i}>
                <div className="overflow-hidden rounded-[2rem] bg-white p-2 shadow-[0_24px_48px_-24px_rgba(38,58,41,0.4)] ring-1 ring-forest/[0.06]" data-id="element-231" data-mp="mnyc3ru55akl">
                  <img src={step.image} alt={step.alt} loading="lazy" decoding="async" className="aspect-[4/3] w-full rounded-[1.6rem] object-cover" data-id="element-232" data-mp="wdhwj1xi5chk" />
                </div>
                <div className="text-center md:text-left" data-id="element-233" data-mp="hovcwo0udykj">
                  <BrushStepLabel number={i + 1} data-id="element-234" data-mp="hn0t5d1b4ci1" />
                  <h3 className="mt-5 font-display text-3xl font-medium leading-tight text-forest md:text-4xl" data-id="element-235" data-mp="cpr6u697sgyf">{step.title}</h3>
                  <p className="mx-auto mt-4 max-w-md text-[16px] leading-relaxed text-forest/70 md:mx-0" data-id="element-236" data-mp="1t2pg44ek9biu">{step.description}</p>
                </div>
              </motion.li>;
        })}
        </ol>
      </div>
    </section>;
}